// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input-module__root--HDkAU {
  position: relative;
  box-sizing: border-box;
  display: flex;
  width: 100%;
  height: 42px;
  align-items: center;
  border: 1px solid #c9c3ba;
  border-radius: 4px;
  background-color: #fff;
  color: #1a1a1a;
  font-size: 0.875rem; /* 14px */
  font-weight: 400;
}

.Input-module__root--HDkAU > input {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: inherit;
  font: inherit;
}

.Input-module__root--HDkAU > input::placeholder {
  color: #999999;
  font-weight: 300;
}

.Input-module__root--HDkAU > input {
  padding-inline: 12px;
  font-weight: 700;
}

.Input-module__root--HDkAU > .Input-module__leading--yckB5,
.Input-module__root--HDkAU > .Input-module__trailing--uDetU {
  position: absolute;
  top: 50%;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: translateY(-50%);
}

.Input-module__root--HDkAU > .Input-module__leading--yckB5 {
  left: 12px;
}

.Input-module__root--HDkAU > .Input-module__trailing--uDetU {
  right: 12px;
}

.Input-module__has-leading--uSsAE > input {
  padding-left: 36px;
}

.Input-module__has-trailing--ew8CK > input {
  padding-right: 36px;
}

.Input-module__is-reverse--gIMr3 {
  border-color: rgb(255 255 255 / 15%);
  background-color: transparent;
  color: #fff;
}

.Input-module__size-small--NdifC {
  box-sizing: border-box;
  height: 40px;
  font-size: 0.8125rem; /* 13px */
}

.Input-module__size-medium--MAmUL {
  box-sizing: border-box;
  height: 48px;
  font-size: 0.90625rem; /* 14.5px */
}

.Input-module__size-large--CFzXe {
  box-sizing: border-box;
  height: 56px;
  font-size: 1rem; /* 16px */
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Input/Input.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,oBAAoB,EAAE,SAAS;AACjC;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB,EAAE,WAAW;AACpC;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe,EAAE,SAAS;AAC5B","sourcesContent":[".root {\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  height: 42px;\n  align-items: center;\n  border: 1px solid #c9c3ba;\n  border-radius: 4px;\n  background-color: #fff;\n  color: #1a1a1a;\n  font-size: 0.875rem; /* 14px */\n  font-weight: 400;\n}\n\n.root > input {\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n}\n\n.root > input::placeholder {\n  color: #999999;\n  font-weight: 300;\n}\n\n.root > input {\n  padding-inline: 12px;\n  font-weight: 700;\n}\n\n.root > .leading,\n.root > .trailing {\n  position: absolute;\n  top: 50%;\n  z-index: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transform: translateY(-50%);\n}\n\n.root > .leading {\n  left: 12px;\n}\n\n.root > .trailing {\n  right: 12px;\n}\n\n.has-leading > input {\n  padding-left: 36px;\n}\n\n.has-trailing > input {\n  padding-right: 36px;\n}\n\n.is-reverse {\n  border-color: rgb(255 255 255 / 15%);\n  background-color: transparent;\n  color: #fff;\n}\n\n.size-small {\n  box-sizing: border-box;\n  height: 40px;\n  font-size: 0.8125rem; /* 13px */\n}\n\n.size-medium {\n  box-sizing: border-box;\n  height: 48px;\n  font-size: 0.90625rem; /* 14.5px */\n}\n\n.size-large {\n  box-sizing: border-box;\n  height: 56px;\n  font-size: 1rem; /* 16px */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Input-module__root--HDkAU`,
	"leading": `Input-module__leading--yckB5`,
	"trailing": `Input-module__trailing--uDetU`,
	"has-leading": `Input-module__has-leading--uSsAE`,
	"has-trailing": `Input-module__has-trailing--ew8CK`,
	"is-reverse": `Input-module__is-reverse--gIMr3`,
	"size-small": `Input-module__size-small--NdifC`,
	"size-medium": `Input-module__size-medium--MAmUL`,
	"size-large": `Input-module__size-large--CFzXe`
};
export default ___CSS_LOADER_EXPORT___;
